import React from 'react';
import * as S from '../styles';

export function DataLabel({ title, label, status, statusId }) {
  return <S.ColLabelData statusid={statusId}>
      <S.TitleData>{title}</S.TitleData>
      <S.LabelData statusLabel={status}>
        <S.LabelData statusLabel={status}>{label}</S.LabelData>
      </S.LabelData>
         </S.ColLabelData>;
}
